export const selectionActionTypes = {
  setSelected: 'SET_SELECTED',
  addSelected: 'ADD_SELECTED',
  removeSelected: 'REMOVE_SELECTED',
  clearSelected: 'CLEAR_SELECTED'
}
